var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.41017C12.2077 3.40914 11.92 3.48306 11.6644 3.62486C11.4088 3.76667 11.1938 3.97163 11.04 4.22017L2.23 18.3202C2.0802 18.5565 2.00045 18.8304 2 19.1102C1.99998 19.3062 2.03892 19.5003 2.11454 19.6812C2.19016 19.8621 2.30097 20.0261 2.44053 20.1638C2.58009 20.3015 2.74561 20.4101 2.92748 20.4833C3.10936 20.5565 3.30397 20.5928 3.5 20.5902H21.5C21.8925 20.5902 22.269 20.4342 22.5465 20.1567C22.8241 19.8791 22.98 19.5027 22.98 19.1102C22.9795 18.8304 22.8998 18.5565 22.75 18.3202L13.96 4.22017C13.8062 3.97163 13.5912 3.76667 13.3356 3.62486C13.08 3.48306 12.7923 3.40914 12.5 3.41017Z",
    stroke: "currentColor",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.17969V14.8597",
    stroke: "currentColor",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.8203V17.7303",
    stroke: "currentColor",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.51d3ac1fa7dfe565c1d849721ce6a134.svg";
export { ForwardRef as ReactComponent };